import styled from 'styled-components/native';

export default styled.Image`
  position: absolute;
  left: 35px;
  bottom: 215px;
  width: 30px;
  height: 26px;
`;
